import { createAction, props } from '@ngrx/store';

export const loadCounts = createAction(
  '[Counts] Load Counts',
  props<{active: string, direction: string, locations: number[] }>()
);

export const loadCountsSuccess = createAction(
  '[Counts] Load Counts Success',
  props<{ inventory: any, total: number }>()
);

export const loadCountsFailure = createAction(
  '[Counts] Load Counts Failure',
  props<{ error: any }>()
);

export const loadInventoryItem = createAction(
  '[Counts] Load Inventory Item',
  props<{ invitmID: number }>()
);

export const loadInventoryItemSuccess = createAction(
  '[Counts] Load Inventory Item Success',
  props<{ data: any }>()
);

export const loadInventoryItemFailure = createAction(
  '[Counts] Load Inventory Item Failure',
  props<{ error: any }>()
);

export const loadFinalizedCounts = createAction(
  '[Counts] Load Finalized Counts',
  props<{active: string, direction: string, currentPage: number, recordsByPage: number, locations: number[] }>()
);

export const loadFinalizedCountsSuccess = createAction(
  '[Counts] Load Finalized Counts Success',
  props<{ data: any }>()
);

export const loadFinalizedCountsFailure = createAction(
  '[Counts] Load Finalized Counts Failure',
  props<{ error: any }>()
);

export const searchFinalizedCounts = createAction(
  '[Counts] Search Finalized Counts',
  props<{query: string, currentPage: number, recordsByPage: number, locations: number[]}>()
);

export const searchFinalizedCountsSuccess = createAction(
  '[Counts] Search Finalized Counts Success',
  props<{ data: any }>()
);

export const searchFinalizedCountsFailure = createAction(
  '[Counts] Search Finalized Counts Failure',
  props<{ error: any }>()
);

export const deleteCount = createAction(
  '[Counts] Delete Counts',
  props<{ invID: number, invBatchName: string }>()
);

export const deleteCountSuccess = createAction(
  '[Counts] Delete Counts Success',
  props<{ invID: any }>()
);

export const deleteCountFailure = createAction(
  '[Counts] Delete Counts Failure',
  props<{ error: any }>()
);

export const paginateCount = createAction(
  '[Counts] Paginate Counts'
);

export const paginateCountSuccess = createAction(
  '[Counts] Paginate Counts Success',
  props<{ inventory: any }>()
);

export const paginateCountFailure = createAction(
  '[Counts] Paginate Counts Failure',
  props<{ error: any }>()
);

export const openCount = createAction(
  '[Counts] Open Counts'
);

export const openCountSuccess = createAction(
  '[Counts] Open Counts Success',
  props<{ inventory: any }>()
);

export const openCountFailure = createAction(
  '[Counts] Open Counts Failure',
  props<{ error: any }>()
);

export const setCurrentID = createAction(
  '[Counts] Set Count ID',
  props<{currentId: any}>()
)

export const setCurrentIDSuccess = createAction(
  '[Counts] Set Count ID Success',
  props<{currentId: any}>()
)

export const setCurrentIDFailure = createAction(
  '[Counts] Set Count ID Failure',
  props<{error: any}>()
)

export const setCurrentType = createAction(
  '[Counts] Set Count Type',
  props<{currentType: any}>()
)

export const loadCount = createAction(
  '[Counts] Load Count',
  props<{ invID: number, active: string, direction: string }>()
  )

export const loadCountSuccess = createAction(
  '[Counts] Load Count Success',
  props<{data: any }>()
)

export const loadCountFailure = createAction(
  '[Counts] Load Count Failure',
  props<{error: any }>()
)

export const loadFinancial = createAction(
  '[Financial] Load Financial',
  props<{invID: number, active: string, direction: string }>()
  )

export const loadFinancialSuccess = createAction(
  '[Financial] Load Financial Success',
  props<{data: any }>()
)

export const loadFinancialFailure = createAction(
  '[Financial] Load Financial Failure',
  props<{error: any }>()
)
export const loadReorder = createAction(
  '[Reorder] Load Reorder',
  props<{ invID: number, active: string, direction: string, pcmType: number }>()
  )

export const loadReorderSuccess = createAction(
  '[Reorder] Load Reorder Success',
  props<{data: any }>()
)

export const loadReorderFailure = createAction(
  '[Reorder] Load Reorder Failure',
  props<{error: any }>()
)

export const loadPO = createAction(
  '[PO] Load PO',
  props<{invID: number, prdMinQty: number}>()
  )

export const loadPOSuccess = createAction(
  '[PO] Load PO Success',
  props<{data: any }>()
)

export const loadPOFailure = createAction(
  '[PO] Load PO Failure',
  props<{error: any }>()
)

export const loadPS = createAction(
  '[PS] Load PS',
  props<{invID: number, prdMinQty: number}>()
  )

export const loadPSSuccess = createAction(
  '[PS] Load PS Success',
  props<{data: any }>()
)

export const loadPSFailure = createAction(
  '[PS] Load PS Failure',
  props<{error: any }>()
)

export const loadPrintCount = createAction(
  '[PO] Load PrintCount',
  props<any>()
  )

export const loadPrintCountSuccess = createAction(
  '[PO] Load PrintCount Success',
  props<{data: any }>()
)

export const loadPrintCountFailure = createAction(
  '[PO] Load PrintCount Failure',
  props<{error: any }>()
)

export const loadExcel = createAction(
  '[PO] Load Excel',
  props<{ invID: number, active: string, direction: string }>()
  )

export const loadExcelSuccess = createAction(
  '[PO] Load Excel Success',
  props<{data: any }>()
)

export const loadExcelFailure = createAction(
  '[PO] Load Excel Failure',
  props<{error: any }>()
)

export const loadMostRecent = createAction(
  '[Home] Load Most Recent Action',
);

export const loadMostRecentSuccess = createAction(
  '[Home] Load Most Recent Success Action',
  props<{ data: any }>()
);

export const loadMostRecentFailure = createAction(
  '[Home] Load Most Recent Failure Action',
  props<{ error: any }>()
);

export const loadMostRecentBasic = createAction(
  '[Home] Load Most Recent Basic Action',
);

export const loadMostRecentBasicSuccess = createAction(
  '[Home] Load Most Recent Basic Success Action',
  props<{ data: any }>()
);

export const loadMostRecentBasicFailure = createAction(
  '[Home] Load Most Recent Basic Failure Action',
  props<{ error: any }>()
);

export const removeMostRecent = createAction(
  '[Home] Remove Most Recent Action',
  props<{ invID: number }>()
);

export const removeMostRecentSuccess = createAction(
  '[Home] Remove Most Recent Success Action',
  props<{ invID: number }>()
);

export const removeMostRecentFailure = createAction(
  '[Home] Remove Most Recent Failure Action',
  props<{ error: any }>()
);

export const setSortType = createAction(
  '[Counts] Set Inventory Type',
  props<{ sortType: {
     active: string,
     direction: string
  } }>()
);

export const finalizeCounts = createAction(
  '[Counts] Finalize Counts',
  props<{
    data: number[];
    overrideOnhand?: boolean;
    overrideMessage?: string;
    overrideItems?: any[];
  }>()
);

export const finalizeCountsSuccess = createAction(
  '[Counts] Finalize Counts Success',
  props<{data: any}>()
);

export const finalizeCountsFailure = createAction(
  '[Counts] Finalize Counts Failure',
  props<{ error: any }>()
);

export const resetCurrentInventory = createAction(
  '[Counts] Reset Current Inventory'
);

export const draftCounts = createAction(
  '[Counts] Draft Counts',
  props<{data: number[]}>()
);

export const draftCountsSuccess = createAction(
  '[Counts] Draft Counts Success',
  props<{data: any}>()
);

export const draftCountsFailure = createAction(
  '[Counts] Draft Counts Failure',
  props<{ error: any }>()
);

export const dummyAction = createAction(
  '[Counts] Dummy Action',
  props<any>()
);

export const setFilterType = createAction(
  '[Counts] Set Filter Type',
  props<{ filterType: string, filterID: number }>()
);


export const searchDraftCounts = createAction(
  '[Counts] Search Draft Counts',
  props<{ query: string, locations: number[] }>()
);

export const searchDraftCountsSuccess = createAction(
  '[Counts] Search Draft Counts Success',
  props<{ inventory: any, total: number }>()
);

export const searchDraftCountsFailure = createAction(
  '[Counts] Search Draft Counts Failure',
  props<{ error: any }>()
);

export const incrementPage = createAction(
  '[Counts] Increment Pagination',
  props<{ currentPage: any }>()
);


export const decrementPage = createAction(
  '[Counts] Decrement Pagination'
);

export const incrementPageSuccess = createAction(
  '[Products] Increment Pagination Success',
  props<{ currentPage: any }>()
);

export const deleteProduct = createAction(
  '[Count] Delete Product Inventory',
  props<{invID: number, prdID: number }>()
);

export const deleteProductSuccess = createAction(
  '[Count] Delete Product Inventory Success',
  props<any>()
);

export const deleteProductFailure = createAction(
  '[Count] Delete Product Inventory Failure',
  props<{ error: any }>()
);